// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__AWc5b","tab":"Tabs_tab__8sLZU","disabled":"Tabs_disabled__nx0PV","selected":"Tabs_selected__CPMsg"};